module.exports = __webpack_public_path__ + "img/loader.1040b5f.gif";